import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgDisney = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M6.99153 4.02126C5.81556 3.92287 4.46319 4.40285 3.42762 5.42642C1.77167 7.06317 1.52567 9.45111 2.85044 10.7603C3.73841 11.6386 5.10518 11.8078 6.41434 11.3315C6.03428 12.1359 5.83678 13.0145 5.83596 13.9042C5.83596 17.2701 8.59588 20 12.0002 20C15.4045 20 18.1644 17.2701 18.1644 13.9042C18.1636 13.0145 17.9661 12.1359 17.586 11.3315C18.8952 11.8078 20.262 11.6386 21.1499 10.7603C22.4747 9.45111 22.2275 7.06437 20.5728 5.42642C18.9168 3.78967 16.5025 3.52088 15.1789 4.83124C14.2909 5.70961 14.1193 7.08477 14.6005 8.37954C13.785 8.00412 12.8979 7.80973 12.0002 7.80973C11.1024 7.80973 10.2153 8.00412 9.39986 8.37954C9.88105 7.08357 9.70945 5.73241 8.82148 4.85524C8.33029 4.36817 7.68137 4.07243 6.99153 4.02126Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgDisney);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const Disney = Memo;
export { Disney as default };
